import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { LocationSelect } from 'ui_system/select/location/LocationSelect';

import { getUserId } from 'data_system/token_auth/selectors';

const Wrapper = styled.div`
  width: 480px;
`;

const LocationSelector = (props) => {
  const { onChange, field } = props;
  const userId = useSelector(getUserId);

  const handleLocationChange = (location) => {
    onChange('location', location.value);
  };

  const locationValue = field.value && {
    value: field.value,
    label: field.value.shopping_center || field.value.address,
  };

  return (
    <Wrapper>
      <LocationSelect
        value={locationValue}
        setValue={handleLocationChange}
        userId={userId}
        styles={{ control: () => ({ fontSize: 14 }) }}
      />
    </Wrapper>
  );
};
export default LocationSelector;

LocationSelector.propTypes = {
  field: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
